// services/axios.config.ts
import axios from 'axios';
import { redirectToLogin } from '../utils/authRedirect';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:1920/api';

const axiosInstance = axios.create({
  baseURL: API_URL,
  timeout: 30000,
});

// Intercepteur pour ajouter le token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');  // ← CORRIGÉ
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Intercepteur pour gérer les erreurs
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Ne déconnecter QUE si le token est expiré/invalide
    // et pas pour un simple problème de permission
    if (error.response?.status === 401) {
      const token = localStorage.getItem('access_token');
      
      // Vérifier si c'est vraiment un problème de token expiré
      if (token) {
        try {
          const payload = JSON.parse(atob(token.split('.')[1]));
          const isExpired = payload.exp * 1000 < Date.now();
          
          if (isExpired) {
            // Token expiré → déconnexion
            localStorage.removeItem('access_token');
            localStorage.removeItem('refresh_token');
            localStorage.removeItem('user');
            redirectToLogin();
          }
          // Sinon, c'est un problème de permission, pas de déconnexion
        } catch {
          // Token malformé → déconnexion
          localStorage.removeItem('access_token');
          localStorage.removeItem('refresh_token');
          localStorage.removeItem('user');
          redirectToLogin();
        }
      }
    }
    
    return Promise.reject(error);
  }
);

export default axiosInstance;